export const SAVE_SMTP_SERVER_DEFAULT = "x/config/advanced/smtp/SAVE_SMTP_SERVER_DEFAULT";
export const saveSmtpServerDefault = data => ({
    type: SAVE_SMTP_SERVER_DEFAULT,
    payload: data
});

export const DELETE_SMTP_SERVER_DEFAULT = "x/config/advanced/smtp/DELETE_SMTP_SERVER_DEFAULT";
export const deleteSmptServerDefault = () => ({
    type: DELETE_SMTP_SERVER_DEFAULT
});